function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 58,
  height: 28,
  rx: 5,
  fill: "white",
  stroke: "#C5C9CB",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9458 10.2291C17.9673 10.0365 18.973 9.94016 19.9631 9.94016C21.4639 9.94016 22.5839 10.2246 23.3231 10.7936C24.0668 11.3626 24.4386 12.2496 24.4386 13.4547C24.4386 14.6195 24.069 15.4998 23.3298 16.0957C22.5951 16.687 21.4841 16.9827 19.9967 16.9827C19.6114 16.9827 19.2172 16.9693 18.814 16.9424V20H16.9458V10.2291ZM20.0169 15.6118C20.9263 15.6118 21.5871 15.4416 21.9993 15.1011C22.4159 14.7562 22.6242 14.2118 22.6242 13.4682C22.6242 12.7245 22.4204 12.1802 22.0127 11.8352C21.605 11.4902 20.9756 11.3178 20.1244 11.3178C19.654 11.3178 19.2172 11.3514 18.814 11.4186V15.5312C19.2082 15.585 19.6092 15.6118 20.0169 15.6118ZM28.8699 20.0874C27.9112 20.0874 26.9771 20.0314 26.0677 19.9194V10.2829C26.5336 10.1798 27.0511 10.0992 27.62 10.041C28.1935 9.98272 28.7423 9.9536 29.2664 9.9536C31.1301 9.9536 32.5323 10.3725 33.4731 11.2102C34.4139 12.0435 34.8843 13.3158 34.8843 15.0272C34.8843 16.201 34.6626 17.1619 34.2191 17.9101C33.78 18.6538 33.117 19.2026 32.2299 19.5565C31.3429 19.9104 30.2229 20.0874 28.8699 20.0874ZM29.3269 18.5754C30.1602 18.5754 30.8434 18.4522 31.3765 18.2058C31.9141 17.9594 32.3151 17.5763 32.5794 17.0566C32.8437 16.5325 32.9759 15.8515 32.9759 15.0138C32.9759 13.7862 32.6779 12.888 32.0821 12.319C31.4863 11.7456 30.5768 11.4589 29.3538 11.4589C28.9147 11.4589 28.4421 11.4992 27.9359 11.5798V18.5082C28.3346 18.553 28.7983 18.5754 29.3269 18.5754ZM43.7098 11.5462H38.4884V14.3418H43.0176V15.8336H38.4884V20H36.6202V10.0544H43.7098V11.5462Z",
  fill: "#C5C9CB"
});

var SvgPdfIcon = function SvgPdfIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 60 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf-icon.f308e41b.svg";
export { ForwardRef as ReactComponent };